import React from 'react';
import scrollIntoView from 'scroll-into-view';

import './WelcomePage.css';

export default class WelcomePage extends React.Component {
  constructor(props) {
    super(props);
    this.dateString = 'May 18, 2018, 3:00 PM';
    this.date = Date.parse(this.dateString);
    this.timer = null;
    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      now: false,
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => this.update(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  onClick = (e) => {
    e.preventDefault();
    scrollIntoView(document.getElementById('rsvp-page'));
  };

  update = () => {
    const time = this.date - Date.parse(new Date());
    if (time < 0) {
      this.setState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        now: true,
      });
    } else {
      const seconds = Math.floor((time / 1000) % 60);
      const minutes = Math.floor((time / 1000 / 60) % 60);
      const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
      const days = Math.floor(time / (1000 * 60 * 60 * 24));
      this.setState({
        days, hours, minutes, seconds, now: false,
      });
    }
  };

  render() {
    const {
      days, hours, minutes, seconds, now,
    } = this.state;

    return (
      <div id="welcome-page" className="welcome-page content-wrapper vertical-align">
        <div className="content">
          <h2>New Manila, Quezon City</h2>
          <h5>Friday, {this.dateString}</h5>
          {now ?
            <h5>Happening now!</h5> :
            <h5>
              {days} Day{days === 1 ? '' : 's'},&nbsp;
              {hours} Hr{hours === 1 ? '' : 's'},&nbsp;
              {minutes} Min{minutes === 1 ? '' : 's'},&nbsp;
              {seconds} Sec{seconds === 1 ? '' : 's'} to go.
            </h5>
          }
          <button
            className="button rsvp-button"
            onClick={this.onClick}
          >
            RSVP Here
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WelcomePage/index.js